var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5732 6.48991H7.51074V3.42741C7.51074 3.29204 7.45697 3.16221 7.36124 3.06649C7.26552 2.97077 7.1357 2.91699 7.00033 2.91699C6.86495 2.91699 6.73513 2.97077 6.63941 3.06649C6.54368 3.16221 6.48991 3.29204 6.48991 3.42741V6.48991H3.42741C3.29204 6.48991 3.16221 6.54368 3.06649 6.63941C2.97077 6.73513 2.91699 6.86495 2.91699 7.00033C2.91699 7.1357 2.97077 7.26552 3.06649 7.36124C3.16221 7.45697 3.29204 7.51074 3.42741 7.51074H6.48991V10.5732C6.48991 10.7086 6.54368 10.8384 6.63941 10.9342C6.73513 11.0299 6.86495 11.0837 7.00033 11.0837C7.1357 11.0837 7.26552 11.0299 7.36124 10.9342C7.45697 10.8384 7.51074 10.7086 7.51074 10.5732V7.51074H10.5732C10.7086 7.51074 10.8384 7.45697 10.9342 7.36124C11.0299 7.26552 11.0837 7.1357 11.0837 7.00033C11.0837 6.86495 11.0299 6.73513 10.9342 6.63941C10.8384 6.54368 10.7086 6.48991 10.5732 6.48991Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.5b0b13f445e7ac174d9c619b97fe50af.svg";
export { ForwardRef as ReactComponent };